import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./Body.css";
 
const Body = () => {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK;
  
  return (
    <div>
      <Container className="errorpage">
        <Row>
          <Col lg={5} className="col1">
            <h1>404 - Page Not Found</h1>
           <p>
              The page you are looking for might have been removed, had its name
              changed or is temporarily unavailable.
            </p>
            <a href={process.env.REACT_APP_ANGELAI_COM_URL}>
              <Button>GO TO HOMEPAGE</Button>
            </a>
          </Col>
          <Col lg={7}>
            
            <img
              srcSet={`
                ${imgCDNURL}angel-ai/angel-meditation-mobile.webp 991w,
                ${imgCDNURL}angel-ai/angel-meditation-desktop.webp 992w
              `}
              className="angel-meditation"
              alt="Angela AI meditation"
              width="900px"
              height="600px"
            />
          </Col>
        </Row>
      </Container>

      <img
        src={`${imgCDNURL}angel-ai/mobilefooter.webp`}
        className="footerimage"
        alt="mobilefooter"
        width="200px"
        height="250px"
      />
     
    </div>
  );
}
export default Body  